import { useTheme } from "@emotion/react";
import { Box } from "@mui/material";
import React from "react";

const CommonFeatureIcon = ({
    icon,
    height,
    width,
    background,
    color,
    handleClick
}) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                background: background || theme.palette.primary.main,
                color: color || theme.palette.secondary.main,
                borderRadius: '50%',
                height: height || '57px',
                width: width || '57px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600
            }}
            onClick={() => {
                if(handleClick) {
                    handleClick();
                }
            }}
        >
            {icon}
        </Box>
    )
}

export default CommonFeatureIcon;